import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarTodosLocaisProdutos(api) {
    let parametros = {
      operacao: 'buscarTodosLocaisProdutos'
    }

    let retorno = {};

    await api.santriGET('/rest/localProduto', parametros, 10, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RLocalProduto.js